import { createAction } from '@reduxjs/toolkit';

export const globalStateResetAction = createAction('resetState');
